import alt from 'components/Dispatcher';
import {Store, StoreMethods} from '@store/@types/alt';
import JobActions, {JobActionsInterface} from '@store/job/JobActions';
import {Job, JobId, ModifyJobRequest} from '@store/@types/kpi';
import {List} from 'immutable';

interface JobStoreState {
  jobs: List<Job>;
}

class JobStore extends Store<JobStoreState> implements StoreMethods<JobActionsInterface> {
  constructor() {
    super();
    this.state = {
      jobs: List(),
    };
    this.bindActions(JobActions);
  }

  createJob(data: ModifyJobRequest): void {}
  createJobError(error: Error): void {}
  createJobSuccess(job: Job): void {}

  deleteJob(id: JobId): void {}
  deleteJobError(error: Error): void {}
  deleteJobSuccess(): void {}

  getJobsInAccount(): void {}
  getJobsInAccountError(error: Error): void {}
  getJobsInAccountSuccess(jobs: List<Job>): void {
    this.setState({
      jobs,
    });
  }

  updateJob(): void {}
  updateJobError(error: Error): void {}
  updateJobSuccess(job: Job): void {}
}

export default alt.createStore(JobStore);
